import "./style.css";
import debounce from "lodash/debounce";
import { useHistory } from "react-router";
import { TableHeader } from "./components";
import { useTranslation } from "react-i18next";
import { getAllSchools } from "../../api/schools";
import { setAlert } from "../../redux/reducers/alert";
import { useDispatch, useSelector } from "react-redux";
import { OnSuccessDialog } from "../../components/dialogs";
import React, { useEffect, useState, useCallback } from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import { ManagementTable } from "../../components/managementTable";
import { AddUserDialog } from "../../components/dialogs/addUserDialog";
import { checkUserSchool, deleteUser, searchUsers } from "../../api/users";
import { StudentConfirmationDeleteDialog } from "../../components/dialogs/studentConfirmationDeleteDialog";

export const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [isAddSchoolDialogVisible, setIsAddSchoolDialogVisible] =
    useState(false);
  const [isOnSuccessDialogVisible, setIsOnSuccessDialogVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [startEntry, setStartEntry] = useState(1)
  const [endEntry, setEndEntry] = useState(10)
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(null);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [SearchValue, setSearchValue] = useState("");
  const [schoolData, setschoolData] = useState();
  const [userId, setUserId] = useState(null);
  const [isEditText, setIsEditText] = useState("");
  const [
    isConfirmationDeleteDialogVisible,
    setIsConfirmationDeleteDialogVisible,
  ] = useState(false);
  const [rowSelectedId, setRowSelectedId] = useState(null);
  const { token } = useSelector((state) => state.user);
  const history = useHistory();
  const { t } = useTranslation();
  let limit = 10;

  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];

  const user = useSelector((state) => state.user);

  const USER_MANAGMENT_COLUMNS = [
    { id: "detail", numeric: false, disablePadding: true, label: t("text_name") },
    { id: "status", numeric: false, disablePadding: true, label: t("text_status") },
    { id: "access", numeric: false, disablePadding: true, label: t("text_access") },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];

  const fetchSchools = async () => {
    try {
      const payload = {
        role: user.role,
        id: user.id,
        schoolId: user.schoolId,
      };
      const response = await getAllSchools(payload, token);
      if (response.status) {
        setschoolData(response?.schools);
      }
    } catch (e) {
    }
  };
  const roleManage = async () => {
    try {
      setLoading(true);
      const payload = {
        id: user.id,
        role: user.role,
      };
      
      if (user.role === "superadmin") {
        const response = await checkUserSchool(payload, page, token, limit);
  
        setStartEntry(page === 0 ? 1 : (page) * limit + 1)
        setEndEntry((page + 1) * limit > response?.find.count
          ? response.find.count
          : (page + 1) * limit)
        if (response.status) {
          setTotalCount(response?.find.count);
          setUsers(response?.find.rows);
        }
      } else {
        const response = await checkUserSchool(payload, page, token, limit);

        setStartEntry(page === 0 ? 1 : (page) * limit + 1)
        setEndEntry((page + 1) * limit > response?.findallUser.count
        ? response.findallUser.count
        : (page + 1) * limit)
        if (response.status) {
          setTotalCount(response?.findallUser.count);
          setUsers(response?.findallUser.rows);
        }
      }
      setLoading(false);
    } catch (error) {
      showErrorAlert(
        error || error.message || t("text_something_went_wrong_try_again_later")
      );
    }
  };

  const openAddUserDialog = () => {
    setIsAddSchoolDialogVisible(true);
  };
  const closeAddSchoolDialog = () => {
    setIsAddSchoolDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const dispatch = useDispatch();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const handlePage = (pageNumber) => {
    setPage(pageNumber);
  }

  useEffect(() => {
    fetchSchools();
  },[])
  
  // fetchUsers();
  useEffect(() => {
    if (SearchValue === "") {
      roleManage();
    } else {
      (async () => {
        setLoading(true);
        try {
          setUsers([]);
          const response = await searchUsers(SearchValue, token);
          if (user.role === "superadmin") {
            if (response.status) {
              setTotalCount(response.find.count);
              setUsers(response.find.rows);
              if (response?.find.count === 0 || response?.find.rows === []) {
                showErrorAlert(t("text_records_not_found"));
              }
            }
          } else {
            if (response.status) {
              setTotalCount(response.findallUser.count);
              setUsers(response.findallUser.rows);
            }
            if (
              response?.findallUser.count === 0 ||
              response?.findallUser.rows === []
            ) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (e) {

          showErrorAlert(e.message || t("text_error_in_searching_users"));
          setLoading(false);
        }
      })();
    }
  }, [page, SearchValue]);

  const debounceSearchString = useCallback(debounce(setSearchValue, 400), []);
  const handleSearching = (e) => {
    setPage(0);
    setTotalCount(0);
    debounceSearchString(e);
  };
  const successCallback = async (id) => {
    setUserId(id);
    closeAddSchoolDialog();
    const payload = {
      id: user.id,
      role: user.role,
    };
    const response = await checkUserSchool(payload, page, token, limit);
    setStartEntry(page === 0 ? 1 : (page) * limit + 1)
      setEndEntry((page + 1) * limit > response?.findallUser?.count
        ? response?.findallUser?.count
        : (page + 1) * limit)
    if (user.role === "superadmin") {
      if (response.status) {
        setTotalCount(response?.find?.count);
        setUsers(response?.find?.rows);
      }
    } else {
      if (response?.status) {
        setTotalCount(response?.findallUser?.count);
        setUsers(response?.findallUser?.rows);
      }
    }
    setIsOnSuccessDialogVisible(true);
  };

  const editSchool = (item) => {
    setIsEditedItem(item);
    setIsAddSchoolDialogVisible(true);
  };

  const editSuccessCallback = async (item) => {
    const updatedUsers = users.map((userItem) => {
      if (userItem.id === item.id) {
        return item;
      } else return userItem;
    });
    closeAddSchoolDialog();
    setUsers(updatedUsers);
  };

  const deleteItem = async () => {
    try {
      const { status, message } = await deleteUser(rowSelectedId, token);
      if (status) {
        showSuccessAlert(message || t("text_user_deleted_successfully"));
        local.push({
          message: message,
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        setIsConfirmationDeleteDialogVisible(false);
      } else {
        showErrorAlert(message || t("text_error_in_deleting_user_please_try_again"));
      }
      deleteCallback(rowSelectedId);
    } catch (err) {
      showErrorAlert(err.message || true("text_error_in_deleting_user_please_try_again"));
    }
  };
  const deleteCallback = async (deletedId) => {
    const updateUsers = users.filter((item) => item.id !== deletedId);
    setUsers(updateUsers);
  };
  const viewItem = async (id) => {

    history.push({
      pathname: `/users/${id}`,
      state: {
        users: users,
      },
    });
  };

  const editCallback = (text) => {
    setIsEditText(text);
  };

  const handleCancel = () => {
    setIsConfirmationDeleteDialogVisible(false);
  };

  const viewDetailWithGenrateDialogue = async (id) => {
    history.push({
      pathname: `/users/${id}`,
      state: {
        openUserDialog: true,
      },
    });
  };

  const goHome = () => {
    window.location.reload();
  };
  return (
    <div className="school-management-page">
      <Typography variant="h4" style={{ fontFamily: "Monsteric, sans-serif", marginBottom: 20 }}>
        {t("text_user_management")}
      </Typography>

      <div className={"school-management-container"}>
        <TableHeader
          handleAdd={openAddUserDialog}
          SearchValue={handleSearching}
        />
        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_users")}
          </div>
        ) : (
          <ManagementTable
            pageNumber={page}
            fetchUsers={roleManage}
            handlePage={handlePage}
            totalCount={totalCount}
            tableFor="users"
            data={users}
            columns={USER_MANAGMENT_COLUMNS}
            editItem={editSchool}
            deleteItem={deleteItem}
            viewItem={viewItem}
            isConfirmationDeleteDialogVisible={
              isConfirmationDeleteDialogVisible
            }
            setIsConfirmationDeleteDialogVisible={
              setIsConfirmationDeleteDialogVisible
            }
            setRowSelectedId={setRowSelectedId}
            startEntry={startEntry}
              endEntry={endEntry}
          />
        )}
      </div>
      {isAddSchoolDialogVisible && (
        <AddUserDialog
          title={isEditedItem ? t("text_edit_user") : t("text_add_user")}
          handleClose={closeAddSchoolDialog}
          open={isAddSchoolDialogVisible}
          successCallback={successCallback}
          isEditedItem={isEditedItem}
          editSuccessCallback={editSuccessCallback}
          user={user}
          schoolData={schoolData}
          editCallback={editCallback}
        />
      )}
      {isOnSuccessDialogVisible && (
        <OnSuccessDialog
          handleClose={closeAddSchoolDialog}
          open={isOnSuccessDialogVisible}
          goHome={goHome}
          isEditedItem={userId}
          viewDetailWithGenrateDialogue={viewDetailWithGenrateDialogue}
          title={t("text_user")}
          editCallback={isEditText}
        />
      )}
      {isConfirmationDeleteDialogVisible && (
        <StudentConfirmationDeleteDialog
          open={isConfirmationDeleteDialogVisible}
          close={handleCancel}
          title={t("text_user")}
          handleDelete={deleteItem}
        />
      )}
    </div>
  );
};
